
export const GET_TREND_SIGNAL_SETTINGS = "GET_TREND_SIGNAL_SETTINGS";
export const GET_TREND_SIGNAL_SETTINGS_SUCCESS = "GET_TREND_SIGNAL_SETTINGS_SUCCESS";
export const GET_TREND_SIGNAL_SETTINGS_ERROR = "GET_TREND_SIGNAL_SETTINGS_ERROR";
